export const ARTWORK_LIST_TAB_STORAGE_KEY = 'laminate-artflow.artwork-list.activeTab';
export const DEFAULT_ARTWORK_LIST_TAB = 'all';

export function getStoredArtworkListTab(defaultTab = DEFAULT_ARTWORK_LIST_TAB) {
  if (typeof window === 'undefined') return defaultTab;

  const storedTab = window.sessionStorage.getItem(ARTWORK_LIST_TAB_STORAGE_KEY);
  return storedTab || defaultTab;
}

export function setStoredArtworkListTab(tab, defaultTab = DEFAULT_ARTWORK_LIST_TAB) {
  if (typeof window === 'undefined') return;

  const nextTab = tab || defaultTab;
  window.sessionStorage.setItem(ARTWORK_LIST_TAB_STORAGE_KEY, nextTab);
}
